import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

const CriminalRecordCheckConsentForm = ({
  criminalRecordSubmitted,
  setCriminalRecordSubmitted,
}: {
  criminalRecordSubmitted: boolean;
  setCriminalRecordSubmitted: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography>
          We reserve the right to request/conduct a background check. Do you
          consent to a background check, if requested by your Organization?
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={criminalRecordSubmitted}
              value={criminalRecordSubmitted}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setCriminalRecordSubmitted(e.target.checked);
              }}
            />
          }
          sx={{ color: "#868686" }}
          label="I consent"
        />
      </Grid>
    </>
  );
};

export default CriminalRecordCheckConsentForm;
